// // import React, { useState, useEffect } from "react";
// // import { Box, Typography, } from "@mui/material";
// // import DepartmentFilters from "../components/DepartmentFilters";
// // import DepartmentSelector from "../components/DepartmentSelector";
// // import EmployeeTableForDepartments from "../components/EmployeeTableForDepartments";
// // import PaginationControls from "../components/PaginationControls";
// // import { useDepartmentHandlers } from "../hooks/useDepartmentHandlers";

// // const DepartmentTable = ({ departments, employees = [], onEmployeesChange, setError, isEdit }) => {
// //   const [filters, setFilters] = useState({ departments: [], status: [] });
// //   const [selectedDepartments, setSelectedDepartments] = useState([]);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [page, setPage] = useState(1);

// //   const rowsPerPage = 10;

// //   const {
// //     handleAddDepartments,
// //     handleDelete,
// //     handleUndo,
// //     filteredEmployees,
// //     totalPages,
// //     currentRows,
// //     handlePageChange,
// //     renderPageNumbers
// //   } = useDepartmentHandlers({
// //     departments,
// //     employees,
// //     filters,
// //     searchTerm,
// //     page,
// //     setPage, // Add setPage to props
// //     selectedDepartments,
// //     setSelectedDepartments,
// //     onEmployeesChange,
// //     setError,
// //     rowsPerPage
// //   });

// //   useEffect(() => {
// //     setPage(1);
// //   }, [filters, searchTerm]);

// //   return (
// //     <Box sx={{ mb: 2 }}>
// //       <div>
// //         <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Departments</Typography>
// //       </div>
      
// //       {!isEdit && (
// //         <DepartmentSelector
// //           departments={departments}
// //           isEdit={isEdit}
// //           selectedDepartments={selectedDepartments}
// //           onAddDepartments={handleAddDepartments}
// //           setSelectedDepartments={setSelectedDepartments}
// //           searchTerm={searchTerm}           // ← Add this
// //           setSearchTerm={setSearchTerm}     // ← Add this
// //         />
// //       )}
// //       <EmployeeTableForDepartments
// //         employees={currentRows}
// //         currentRows={currentRows}
// //         onDelete={handleDelete}
// //         onUndo={handleUndo}
// //         page={page}
// //         rowsPerPage={rowsPerPage}
// //       />


// //       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 4, gap: 1 }}>
// //         <PaginationControls
// //           page={page}
// //           totalPages={totalPages}
// //           onPageChange={handlePageChange}
// //           renderPageNumbers={renderPageNumbers}
// //         />
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default DepartmentTable;





// import React, { useState, useEffect } from "react";
// import { Box, Typography, CircularProgress } from "@mui/material";
// import DepartmentFilters from "../components/DepartmentFilters";
// import DepartmentSelector from "../components/DepartmentSelector";
// import EmployeeTableForDepartments from "../components/EmployeeTableForDepartments";
// import PaginationControls from "../components/PaginationControls";
// import { useDepartmentHandlers } from "../hooks/useDepartmentHandlers";

// const DepartmentTable = ({ departments, employees = [], onEmployeesChange, setError, isEdit }) => {
//   const [filters, setFilters] = useState({ departments: [], status: [] });
//   const [selectedDepartments, setSelectedDepartments] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(1);

//   const rowsPerPage = 10;

//   const {
//     handleAddDepartments,
//     handleDelete,
//     handleUndo,
//     filteredEmployees,
//     totalPages,
//     currentRows,
//     handlePageChange,
//     renderPageNumbers,
//     isLoading
//   } = useDepartmentHandlers({
//     departments,
//     employees,
//     filters,
//     searchTerm,
//     page,
//     setPage,
//     selectedDepartments,
//     setSelectedDepartments,
//     onEmployeesChange,
//     setError,
//     rowsPerPage
//   });

//   useEffect(() => {
//     setPage(1);
//   }, [filters, searchTerm]);

//   return (
//     <Box sx={{ mb: 2 }}>
//       <div>
//         <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Departments</Typography>
//       </div>
      
//       {!isEdit && (
//         <DepartmentSelector
//           departments={departments}
//           isEdit={isEdit}
//           selectedDepartments={selectedDepartments}
//           onAddDepartments={handleAddDepartments}
//           setSelectedDepartments={setSelectedDepartments}
//           searchTerm={searchTerm}
//           setSearchTerm={setSearchTerm}
//         />
//       )}
      
//       {isLoading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
//           <CircularProgress />
//         </Box>
//       ) : (
//         <EmployeeTableForDepartments
//           employees={currentRows}
//           currentRows={currentRows}
//           onDelete={handleDelete}
//           onUndo={handleUndo}
//           page={page}
//           rowsPerPage={rowsPerPage}
//         />
//       )}

//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 4, gap: 1 }}>
//         <PaginationControls
//           page={page}
//           totalPages={totalPages}
//           onPageChange={handlePageChange}
//           renderPageNumbers={renderPageNumbers}
//         />
//       </Box>
//     </Box>
//   );
// };

// export default DepartmentTable;




import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import DepartmentFilters from "../components/DepartmentFilters";
import DepartmentSelector from "../components/DepartmentSelector";
import EmployeeTableForDepartments from "../components/EmployeeTableForDepartments";
import PaginationControls from "../components/PaginationControls";
import { useDepartmentHandlers } from "../hooks/useDepartmentHandlers";

const DepartmentTable = ({ departments, employees = [], onEmployeesChange, setError, isEdit, examid }) => {
  const [filters, setFilters] = useState({ departments: [], status: [] });
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const rowsPerPage = 10;

  const {
    handleAddDepartments,
    handleDelete,
    handleUndo,
    filteredEmployees,
    totalPages,
    totalCount,
    currentPage,
    currentRows,
    handlePageChange,
    renderPageNumbers,
    isLoading
  } = useDepartmentHandlers({
    departments,
    employees,
    filters,
    searchTerm,
    page,
    setPage,
    selectedDepartments,
    setSelectedDepartments,
    onEmployeesChange,
    setError,
    examid,
    rowsPerPage
  });

  useEffect(() => {
    setPage(1);
  }, [filters, searchTerm]);

  return (
    <Box sx={{ mb: 2 }}>
      <div>
        <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Departments</Typography>
      </div>
      
      {!isEdit && (
        <DepartmentSelector
          departments={departments}
          isEdit={isEdit}
          selectedDepartments={selectedDepartments}
          onAddDepartments={handleAddDepartments}
          setSelectedDepartments={setSelectedDepartments}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      )}
      
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {totalCount > 0 && (
            <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
              Showing {currentRows.length} of {totalCount} employees
            </Typography>
          )}

          
          <EmployeeTableForDepartments
            employees={currentRows}
            currentRows={currentRows}
            onDelete={handleDelete}
            onUndo={handleUndo}
            page={currentPage}
            rowsPerPage={rowsPerPage}
          />
        </>
      )}

      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 4, gap: 1 }}>
          <PaginationControls
            page={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            renderPageNumbers={renderPageNumbers}
          />
        </Box>
      )}
    </Box>
  );
};

export default DepartmentTable;
